/* eslint react/prop-types: off */
import React from 'react'
import {
  ActionButton,
  FilterBar,
  FilterSearch,
  FilterSelector,
  FilterWrapper,
  FormInputCheckbox,
  Icon,
  Tab,
  Tabs
} from 'camino-react'

import _, { isEmpty } from 'lodash'

import CustomFilterForm from 'Components/Tables/Ticket/CustomFilterForm'
import MyCustomFiltersModal from 'Components/Tables/Ticket/CustomFiltersModal'
import MergeTicketsModal from 'Components/Tables/Ticket/MergeTicketsModal'
import BulkUpdateModal from 'Components/Tables/Ticket/BulkUpdateModal'
import { useState } from 'react'

const Header = ({
  tabs,
  initialFilterOptions,
  addFilter,
  setFilters,
  filterText,
  searchFilter,
  searchText,
  filters,
  setModalToDisplay,
  customFilterFormProps,
  myCustomFiltersModalProps,
  mergeTicketsModalProps,
  toggleShowCopyModal,
  ticketsToAction,
  bulkUpdateTicketsModalProps,
  handleColumn,
  allColumns
}) => {
  const [expanded, setExpanded] = useState(false)

  const customFilters = _.map(myCustomFiltersModalProps.customFilters, ticketFilter => (
    Object.assign(
      {},
      ticketFilter,
      {
        apply: () => {
          myCustomFiltersModalProps.removeModal()
          setFilters(ticketFilter.filters)
        }
      }
    )
  ))

  const ticketActions = [
    {
      text: 'Merge Selected',
      onClick: () => setModalToDisplay('mergeTicketsModalVisible'),
      disabled: ticketsToAction.length === 1
    },
    {
      text: 'Copy ticket',
      onClick: () => toggleShowCopyModal(true),
      disabled: ticketsToAction.length > 1
    },
    {
      text: 'Update',
      onClick: () => setModalToDisplay('bulkUpdateTickets')
    }
  ]

  const extraFormComponent = (
    <div>
      <button
        type="button"
        onClick={() => setModalToDisplay('customFiltersModalVisible')}
        className="bg-blue-500 text-white p-2 rounded-full w-full mt-3 hover:bg-blue-700 duration-300 font-bold text-2xl"
      >
        MY FILTERS
      </button>

      <button
        type="button"
        onClick={() => setModalToDisplay('customFilterFormVisible')}
        className={`bg-blue-500 text-white p-2 rounded-full w-full mt-3 hover:bg-blue-700 duration-300 font-bold text-2xl ${isEmpty(filters) && 'bg-gray-200'}`}
      >
        SAVE FILTERS
      </button>

      <div className="relative">
        <button type="button" onClick={() => setExpanded(!expanded)} className="bg-blue-500 text-white p-1 rounded-full w-full mt-3 hover:bg-blue-700 duration-300 font-bold text-2xl">
          <div className="flex center items-center font-semibold leading-none">
            <div className="text-center flex-1 ml-3 font-bold">COLUMNS</div>
            <div className={`${expanded ? '' : '-'}rotate-90 transform duration-300 text-2xl flex items-center justify-center`}>
              <Icon type="chevron-down" />
            </div>
          </div>
        </button>

        <div className={`absolute hidden ${expanded && 'block'} shadow-md rounded-md w-64 mt-4 bg-white p-3 z-10 border border-gray-200 left-full ml-4 -top-4`}>
          {allColumns.slice(1).map(({ accessor, enabled, text }) => (
            <FormInputCheckbox
              value={enabled}
              onValue={() => handleColumn(accessor)}
            >
              {text}
            </FormInputCheckbox>
          ))}
        </div>
      </div>
    </div>
  )

  return (
    <React.Fragment>
      <div className="flex justify-between mb-3">
        {_.some(tabs) && (
          <Tabs>
            {_.map(tabs, tab => (
              <Tab key={tab.text} {...tab}>
                {tab.text}
              </Tab>
            ))}
          </Tabs>
        )}

        {ticketsToAction.length >= 1 && (
          <ActionButton
            size="compact"
            color="outline-secondary"
            actions={ticketActions}
          >
            Ticket Actions
          </ActionButton>
        )}
      </div>

      <FilterWrapper>
        <FilterSelector
          options={initialFilterOptions}
          addFilter={addFilter}
          text={filterText}
          extraFormComponent={extraFormComponent}
        />
        <FilterSearch filter={searchFilter} placeholder={searchText} />
      </FilterWrapper>

      <FilterBar filters={filters} />

      {customFilterFormProps.showModal && (
        <div className="absolute z-200">
          <CustomFilterForm
            errors={customFilterFormProps.errors}
            message={customFilterFormProps.message}
            filters={filters}
            savingStatus={customFilterFormProps.savingStatus}
            submit={() => customFilterFormProps.submit(filters)}
            customFiltersFields={customFilterFormProps.customFiltersFields}
            updateCustomFilterFields={customFilterFormProps.updateCustomFilterFields}
            showModal={customFilterFormProps.showModal}
            removeModal={customFilterFormProps.removeModal}
          />
        </div>
      )}

      {myCustomFiltersModalProps.showModal && (
        <div className="absolute z-200">
          <MyCustomFiltersModal
            customFilters={customFilters}
            customFiltersFields={myCustomFiltersModalProps.customFiltersFields}
            showModal={myCustomFiltersModalProps.showModal}
            removeModal={myCustomFiltersModalProps.removeModal}
            customFilterUsers={myCustomFiltersModalProps.customFilterUsers}
            loadingCustomFilters={myCustomFiltersModalProps.loadingCustomFilters}
          />
        </div>
      )}

      {mergeTicketsModalProps.showModal && (
        <div className="absolute z-200">
          <MergeTicketsModal
            showModal={mergeTicketsModalProps.showModal}
            removeModal={mergeTicketsModalProps.removeModal}
            ticketsToMerge={mergeTicketsModalProps.ticketsToAction}
          />
        </div>
      )}

      {bulkUpdateTicketsModalProps.showModal && (
        <div className="absolute z-200">
          <BulkUpdateModal {...bulkUpdateTicketsModalProps} />
        </div>
      )}
    </React.Fragment>
  )
}

export default Header
